import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCloudArrowUp24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCloudArrowUp24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m18.929 11.434-.094.797.611.52A2.94 2.94 0 0 1 20.5 15c0 1.621-1.359 3-3.115 3H6.615C4.86 18 3.5 16.621 3.5 15c0-1.1.617-2.08 1.57-2.606l.897-.495-.134-1.015a3 3 0 0 1-.025-.384c0-1.621 1.358-3 3.115-3q.255 0 .494.037l.674.103.52-.44A5.1 5.1 0 0 1 13.924 6c2.819 0 5.039 2.218 5.039 4.875q0 .285-.033.559M2 15c0-1.68.945-3.147 2.346-3.92a4 4 0 0 1-.038-.58c0-2.485 2.066-4.5 4.615-4.5q.368 0 .721.055A6.6 6.6 0 0 1 13.923 4.5c3.611 0 6.539 2.854 6.539 6.375q0 .372-.043.734A4.44 4.44 0 0 1 22 15c0 2.485-2.066 4.5-4.615 4.5H6.615C4.066 19.5 2 17.485 2 15m6.995-1.944a.75.75 0 0 1 0-1.061l2.474-2.475.53-.53.531.53 2.475 2.475a.75.75 0 0 1-1.06 1.06l-1.195-1.194V15.5a.75.75 0 0 1-1.5 0v-3.64l-1.195 1.196a.75.75 0 0 1-1.06 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCloudArrowUp24);
